import 'whatwg-fetch';

if (typeof window === 'object') {
  // IE cannot process the keys of anything but objects, unlink modern browsers.
  try {
    window.Object.keys(false);
  } catch (err) {
    const { keys } = window.Object;
    window.Object.keys = (o: unknown): string[] => {
      try {
        if (typeof o === 'string') {
          return keys(o.split(''));
        }
        return keys(o as {});
      } catch (err2) {
        return [];
      }
    };
  }

  // TODO: Fix this in `@narvar/nth-bundle-dynamic-header`.
  if (typeof document.querySelectorAll('body').forEach === 'undefined') {
    // @ts-ignore
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
}

export {};
